export interface HelpEntry {
  title: string
  body: string
  bullets?: string[]
  link?: { label: string; url: string }
}

export const helpContent: Record<string, HelpEntry> = {
  dashboard: {
    title: 'Dashboard',
    body: 'Your active and inactive campaigns live here. Filter by status, edit dates, activate or pause, view results, and copy share links.',
    bullets: [
      'Click + New campaign in the sidebar to start a brand-new campaign.',
      'Use the filter chips to narrow by Active / Scheduled / Paused / Ended.',
      'The actions menu on each row opens per-campaign options.',
    ],
  },
  experiences: {
    title: 'Experience Library',
    body: 'Build reusable quizzes and surveys that any campaign can attach. Each experience has a family with versions (drafts and published).',
    bullets: [
      'Create new experience to start a new family.',
      'Edit drafts freely; published versions are read-only — fork to a draft to change them.',
      'Attach an experience to a campaign from inside the campaign builder, or from the editor sidebar.',
    ],
  },
  experience_editor: {
    title: 'Experience Editor',
    body: 'Configure questions, themes, and cycling schedules for an experience. Save as draft to iterate, or publish when ready.',
    bullets: [
      'Configuration controls time limits, attempts, and the leaderboard.',
      'Questions opens the question bank with drag-reorder.',
      'Cycling schedule controls weekly rounds, intervals, and killswitches.',
    ],
  },
  analytics: {
    title: 'Analytics',
    body: 'Per-campaign performance, historical reports, simulator runs, and visual boards.',
    bullets: [
      'Reach the Standard view from the Analytics rail item.',
      'Each campaign row also has its own Analytics shortcut.',
    ],
  },
  billing: {
    title: 'Billing',
    body: 'Manage your plan, top up tokens, and check your account limits.',
    bullets: [
      'Plans show the recurring monthly subscription tiers.',
      'Token Top-Ups are one-time packs for extra capacity.',
      'Expansions are recurring add-ons that raise specific caps.',
    ],
  },
  account: {
    title: 'Account',
    body: 'Your personal details, the org and tenant you’re currently active in, and the other workspaces you can switch into.',
    bullets: [
      'Active Context is the org and tenant your actions count against.',
      'Members lets owners and admins invite or remove people.',
      'Switch makes a different membership the active one (refreshes your session).',
    ],
  },
  edit_campaign: {
    title: 'Edit campaign',
    body: 'Change any setting on this campaign — the attached experience, dates, platform, and more.',
    bullets: [
      'Sections expand top-to-bottom — fill them in order.',
      'Save before navigating away.',
    ],
  },
}

export function helpFor(key: string | undefined | null): HelpEntry | undefined {
  if (!key) return undefined
  return helpContent[key]
}
